import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus, Eye } from 'lucide-react';

const GuestBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-sage-100 via-sage-50 to-sage-100 border-b border-sage-200">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-sage-200 flex items-center justify-center">
            <Eye className="w-4 h-4 text-sage-600" />
          </div>
          <p className="text-sm text-sage-700 truncate">
            <span className="font-medium">You're browsing as a guest.</span>
            {' '}Sign up for full access to personalized plans and tracking!
          </p>
        </div>
        <Link
          to="/register"
          className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg
            bg-sage-600 hover:bg-sage-700 text-white text-sm font-medium
            shadow-sm hover:shadow-md transition-all"
        >
          <UserPlus className="w-4 h-4" />
          Sign Up
        </Link>
      </div>
    </div>
  );
};

export default GuestBanner;
